import { addListener, preventDefault } from './event.js';

/**
 * Prevents touchmove events on the document. This is useful if you need to prevent touch actions
 * from scrolling the page while dragging, but for some reason you can't do this on touchstart.
 */
function preventTouchMove() {
    return addListener(document, 'touchmove', preventDefault, { passive: false });
}

export { preventTouchMove };
//# sourceMappingURL=touch.js.map
